module.exports = __webpack_public_path__ + "svg/new-cup-big.7379454abf949d37d7cefd6d026023ed.svg";